<template>
    <div>
        <b-modal id="modalItemsRotinas" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirRotinas" centered>
            <template #modal-header>
                <div class="col-10">
                    <h4>Configuração de rotinas!</h4>
                </div>
                <div class="col-2" style="justify-content: end; display: flex;">
                    <button class="btn btn-success mb-2" @click="modalConfigRotina = true, editarRotina = null">
                        <i class="fas fa-plus mr-1"></i>Adicionar
                    </button>
                </div>
            </template>

            <table class="table table-striped ">
                <thead>
                    <tr> 
                        <th scope="col-3">Nome Rotina</th>
                        <th scope="col-3">Caminho</th>
                        <th scope="col-3">Observação</th>
                        <th scope="col-3">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="rotina in rotinas" :key="rotina.nr_sequencial">
                        <td>{{ rotina.nome_rotina }}</td>
                        <td>{{ rotina.ds_caminho }}</td>
                        <td>{{ rotina.ds_observacao }}</td>
                        <th scope="row"><button class="btn btn-warning mr-2" @click="editaRotina(rotina)"><i
                                    class="fa fa-pen"></i></button>
                            <button class="btn btn-danger" @click="excluirRotina(rotina)"><i
                                    class="fa fa-trash"></i></button>
                        </th>
                    </tr>
                </tbody>
            </table>
            <template #modal-footer>
                <div class="w-100">
                    <div class="row center" style="justify-content: center; ">
                        <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                            Fechar
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
        <modal-config-rotina v-if="modalConfigRotina" @closeModal="modalConfigRotina = false"
            :rotina="editarRotina"></modal-config-rotina>
    </div>
</template>

<script>
import ModalConfigRotina from './ModalConfigRotina.vue';

export default {
    data() {
        return {
            exibirRotinas: true,
            modalConfigRotina: false,
            editarRotina: ''
        }
    },

    computed: {
        rotinas() {
            return this.$store.getters['painel/getRotinas']
        }
    },

    components: {
        ModalConfigRotina
    },

    created() {
        this.$store.dispatch('painel/getRotinas')
    },

    methods: {
        editaRotina(rotina) {
            this.modalConfigRotina = true
            this.editarRotina = rotina
        },

        excluirRotina(rotina) {
            this.$swal.fire({
                title: 'Excluir a rotina?',
                text: `Deseja excluir a rotina?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirmar'
            }).then(result => {
                if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {
                    this.$store.dispatch('painel/deleteRotina', { data: rotina }).then(response => {
                        this.$store.dispatch('painel/getRotinas')
                        
                        this.$swal.fire({
                            title: 'Excluído com sucesso!',
                            text: 'A rotina foi excluída com sucesso',
                            icon: 'success',
                            timer: 1000
                        })
                    }).catch((error) => {
                        this.$swal.fire({
                            title: 'Ooops!',
                            text: 'Existe um agendamento com esta rotina, exclua esta rotina depois tente novamente!',
                            icon: 'warning'
                        })
                    })
                }
            })
        }
    }
}
</script>